.panel {
  display: flex;
  flex-direction: column;
  gap: var(--sp-5);
  width: var(--compare-w);
  flex: 0 0 var(--compare-w);
  padding: var(--sp-5);
  background: var(--surface);
  border-left: 1px solid var(--border);
  overflow: hidden;
}

.heading {
  font-size: var(--fs-md);
  font-weight: 700;
  color: var(--text);
}

.hint {
  margin: 0;
  color: var(--text-3);
  font-size: var(--fs-sm);
}

.tableWrap {
  overflow-x: auto;
  border: var(--bw) solid var(--border);
  border-radius: var(--radius);
}

.table {
  width: 100%;
  border-collapse: collapse;
  font-size: var(--fs-sm);
}

.table th,
.table td {
  padding: var(--sp-3) var(--sp-4);
  border-bottom: 1px solid var(--border);
  text-align: left;
  white-space: nowrap;
}

.table thead th {
  background: var(--surface-2);
  -webkit-backdrop-filter: var(--glass-blur);
  backdrop-filter: var(--glass-blur);
  color: var(--text-2);
  font-weight: 600;
  position: sticky;
  top: 0;
}

.table tbody th {
  color: var(--text-2);
  font-weight: 500;
  background: var(--surface);
  -webkit-backdrop-filter: var(--glass-blur);
  backdrop-filter: var(--glass-blur);
}

.table tbody tr:last-child th,
.table tbody tr:last-child td {
  border-bottom: none;
}

.variantHeader {
  display: inline-flex;
  align-items: center;
  gap: var(--sp-2);
}

.dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex: 0 0 auto;
}

.best {
  background: var(--surface-2);
  font-weight: 700;
}

.checkmark {
  margin-right: var(--sp-2);
}

.warnValue {
  font-weight: 600;
}

.exportRow {
  display: flex;
  justify-content: flex-end;
}

.exportTextarea {
  width: 100%;
  min-height: 240px;
  resize: vertical;
}

/* ── Мобильный вид (порог продублирован в ui/shell/useIsMobile.ts) ────────
   Сводка стоит последней в ленте, в самом низу страницы, и разворачивается во
   всю её ширину. Таблица вариантов по ширине экрана не проходит никогда,
   поэтому едет внутри себя по обеим осям, а не растягивает страницу. */
@media (max-width: 720px) {
  .panel {
    width: 100%;
    flex: none;
    border-left: none;
    padding: var(--sp-5) var(--sp-4) var(--sp-6);
  }

  /* Шапка-кнопка аккордеона (D11), тот же приём, что у библиотеки:
     «Итог · N вариантов» + шеврон вместо простого <h2>. На десктопе не
     рендерится вовсе — там сворачивание закрыто за кнопкой на шве (App.tsx). */
  .accordionHead {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--sp-3);
    width: 100%;
    min-height: 44px;
    padding: 0;
    background: transparent;
    border: none;
    color: var(--text);
    font: inherit;
    text-align: left;
    cursor: pointer;
  }

  .accordionTitle {
    font-size: var(--fs-md);
    font-weight: 700;
  }

  /* Шеврон свой: у ComparePanel нет группового аккордеона, откуда можно было
     бы переиспользовать готовый класс (как в LibraryPanel). */
  .chevron {
    flex: 0 0 auto;
    transition: transform 120ms ease;
  }

  .chevron.collapsed {
    transform: rotate(-90deg);
  }

  .tableWrap {
    /* Высота ограничена, иначе длинный список метрик уводит конец страницы
       далеко вниз и до кнопки выгрузки приходится долго скроллить. */
    max-height: 60vh;
    overflow: auto;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
  }

  /* Шапка и столбец метрик остаются на виду при прокрутке по обеим осям:
     иначе, уехав к третьему варианту, уже не понять, что за строка перед тобой. */
  .table thead th {
    z-index: 2;
  }

  .table tbody th {
    position: sticky;
    left: 0;
    z-index: 1;
  }

  .table thead th:first-child {
    position: sticky;
    left: 0;
    z-index: 3;
  }
}

@media (max-width: 720px) and (prefers-reduced-motion: reduce) {
  .chevron {
    transition: none;
  }
}
